/**
 * The id of the person signed in on this browser, from the session data the
 * auth flow stores (useAuth writes `user_data`). Query keys for answers that
 * depend on who is asking include it, so a different sign-in never reuses the
 * previous person's cached answer. '' when nobody is stored.
 */
export function signedInUserId(): string {
  try {
    const stored = localStorage.getItem('user_data');
    const id = stored ? (JSON.parse(stored) as { id?: unknown })?.id : undefined;
    return typeof id === 'string' ? id : '';
  } catch {
    return '';
  }
}
